import React, { useState, useContext, useEffect } from "react";
import "../../../styles/casedetails.css";
import { Outlet, Link, useNavigate, Navigate } from "react-router-dom";
import { ShareContext } from "../../../context/ShareContext";
import * as Constants from "../../../constants";
import JisButton from "../../controls/jisButton";

function ViewCaseInfo({ caseId, caseinfo = null, isAction = false }) {
  const { activePage, token, profile, frequentData, setIsExpired } =
    useContext(ShareContext);
  const [fiats, setFiats] = useState([]);
  const [loading, setLoading] = useState(false);
  const [cinfo, setCaseInfo] = useState(caseinfo);

  const onLoad = async () => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/filing/case-details/${caseId}/caseinfo`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await resp.json();
      if (data.code == 0) {
        setCaseInfo(data.caseinfo);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  console.log({ caseinfo });

  return (
    <div>
      {/* {isAction && (
        <div style={{ textAlign: "right" }}>
          <JisButton>Upload FIAT (if Applicable)</JisButton>
        </div>
      )} */}
      <section class="case-info">
        <div className="summary summary_wrapper">
          <div>
            <div className="label">Case Title</div>
            <div className="value">{caseinfo?.caseTitle}</div>
          </div>
          <div>
            <div className="label">Suit Number</div>
            <div className="value">{caseinfo?.caseNumber}</div>
          </div>
          <div>
            <div className="label">Division</div>
            <div className="value">
              {
                Constants.getItemById(
                  frequentData?.divisions,
                  caseinfo?.divisionId,
                )?.title
              }
            </div>
          </div>
          <div>
            <div className="label">Case Classification</div>
            <div className="value">
              {
                Constants.getItemById(
                  frequentData?.casecategories,
                  caseinfo?.caseCategoryId,
                )?.categoryTitle
              }
            </div>
          </div>
          <div>
            <div className="label">Case Type</div>
            <div className="value">
              {
                Constants.getItemById(
                  frequentData?.casetype,
                  caseinfo?.caseTypeId,
                )?.caseType1
              }
            </div>
          </div>
          <div>
            <div className="label">Date Filed</div>
            <div className="value">
              { caseinfo?.fileDate!=null? Constants.momentDate(caseinfo?.fileDate).format(
                "DD MMMM, YYYY",
              ):'N/A'}
            </div>
          </div>
          <div>
            <div className="label">Date Case Initiated</div>
            <div className="value">
              {Constants.momentDate(caseinfo?.createdOn).format(
                "DD MMMM, YYYY",
              )}
            </div>
          </div>

          <div>
            <div className="label">Cause of Action(s)</div>
            <div className="value">
              {caseinfo?.causes?.length > 0
                ? caseinfo.causes
                    .map((cause) => cause.description.replace(/-/g, " "))
                    .join(", ")
                : "N/A"}
            </div>
          </div>
          <div>
            <div className="label">Process Mode</div>
            <div className="value">{caseinfo?.processType}</div>
          </div>
          <div>
            <div className="label">Case Status</div>
            <div className="value">
              {
                Constants.getItemById(
                  frequentData?.casestatuses,
                  caseinfo?.caseStatusId,
                )?.description
              }
            </div>
          </div>
          {caseinfo?.orderStatus != null && (
            <div>
              <div className="label">Judgement Status</div>
              <div className="value">{caseinfo?.orderStatus}</div>
            </div>
          )}
          {caseinfo?.concludedOn != null && (
            <div>
              <div className="label">Judgement Date</div>
              <div className="value">
                {Constants.momentDate(caseinfo?.concludedOn).format(
                  "DD MMMM, YYYY",
                )}
              </div>
            </div>
          )}
          {caseinfo?.judge != null && (
            <div>
              <div className="label">Judge</div>
              <div className="value">{Constants.judgeName(caseinfo.judge)}</div>
            </div>
          )}
        </div>

        {/* <div className="wide">
          <div>
            <h3>Cause of Actions</h3>
            <div style={{ display: "flex" }}>
              {caseinfo?.causes?.map((opt) => (
                <div key={opt.id} className="selected">
                  <strong>{opt.description}</strong>
                </div>
              ))}
            </div>
          </div>
        </div> */}
      </section>

      <div
        style={{ marginBottom: "24px", marginTop: "24px" }}
        className="table"
      >
        {/* <div class="section-cases">
          <span>Claims Details</span>
        </div> */}
        <div className="table-header">
          <p>Claims Details </p>
        </div>
        <div className="table-wrapper">
          <table className="case-details-table">
            <thead>
              <tr>
                <th className="col-title">Claim Description</th>
                <th>Claim Value</th>
                <th>Claim Type</th>
              </tr>
            </thead>
            <tbody>
              {caseinfo?.claims.map((opt) => (
                <tr key={opt.id}>
                  <td>{opt.claim || "N/A"}</td>
                  <td>
                    <strong>{opt.currencyType}</strong>{" "}
                    {Constants.formatCurrency(opt.claimValue) || "N/A"}
                  </td>
                  <td>{opt.type || "N/A"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="table">
        <div class="table-header">
          <p>Legal Counsel</p>
        </div>
        <div className="table-wrapper">
          <table className="case-details-table">
            <thead>
              <tr>
                <th className="col-title">Name</th>
                <th className="col-title">Counsel For</th>
                <th>Phone Number</th>
                <th className="col-title">Email</th>
              </tr>
            </thead>
            <tbody>
              {caseinfo?.legalcounsels?.map((opt, ind) => (
                <tr key={ind}>
                  <td>
                    {opt.firstName || opt.lastName
                      ? `${opt.firstName} ${opt.lastName ?? ""}`
                      : "N/A"}
                    {/* {opt.firstName} {opt.lastName ?? ""} */}
                  </td>
                  <td>N/A</td>
                  {/* <td>{opt.lastName ?? ""}</td> */}
                  <td>{opt.primaryContactNumber || "N/A"}</td>
                  <td>{opt.primaryEmail || "N/A"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {/* {caseinfo?.fiats?.length > 0 && (
        <div className="table">
          <div class="section-cases">
            <span>FIAT</span>
          </div>
          <table class="case-table">
            <thead>
              <tr>
                <th className="col-title">Legal Counsel</th>
                <th className="col-medium">Date Initiated</th>
                <th className="col-medium">Approval Status</th>
                <th>Allow Payment</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {caseinfo?.fiats?.map((opt, ind) => (
                <tr key={ind}>
                  <th>
                    {opt?.legalCounsel.firstName}{" "}
                    {opt?.legalCounsel.lastName ?? ""}
                  </th>
                  <td>
                    {Constants.momentDate(opt.createdOn).format("DD MMM, YYYY")}
                  </td>
                  <td>
                    {opt.isApproved == null
                      ? "pending"
                      : opt?.isApproved
                      ? "Approved"
                      : "Rejected"}
                  </td>
                  <td>
                    {opt.isApproved == null
                      ? "pending"
                      : opt?.isPay && opt?.isApproved
                      ? "Zero Payment"
                      : "Payment Required"}
                  </td>
                  <td></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )} */}

      {/* {caseinfo?.presessions?.length > 0 && (
        <div className="table">
          <div class="section-cases">
            <span>Pre-Session Meeting</span>
          </div>
          <table class="case-table">
            <thead>
              <tr>
                <th className="col-medium">Pre Session Date</th>
                <th>Tentative Dates</th>
                <th>Selected Date</th>

                <th className="col-medium">Created on</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {caseinfo?.presessions?.map((opt, ind) => (
                <tr key={ind}>
                  <th>{Constants.displayDate(opt?.preDate)} </th>
                  <td>{opt?.availableDates}</td>
                  <td>
                    {opt.dateSelected == null ? "pending" : opt.dateSelected}
                  </td>
                  <td>{Constants.displayDateTime(opt.createdOn)}</td>
                  <td></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {caseinfo?.mediations?.length > 0 && (
        <div className="table">
          <div class="section-cases">
            <span>Mediation Meeting</span>
          </div>
          <table class="case-table">
            <thead>
              <tr>
                <th className="col-medium">Mediation Date</th>
                <th>Parties Settled</th>
                <th className="col-title">Summary</th>

                <th className="col-medium">Created on</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {caseinfo?.mediations?.map((opt, ind) => (
                <tr key={ind}>
                  <th>{Constants.displayDate(opt?.mediationDate)} </th>
                  <td>
                    {opt.partiesSettled == null
                      ? "pending"
                      : opt?.partiesSettled
                      ? "Settled"
                      : "not Settled"}
                  </td>
                  <td>{opt.summary}</td>
                  <td>{Constants.displayDateTime(opt.createdOn)}</td>
                  <td></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )} */}
    </div>
  );
}

export default ViewCaseInfo;
